$(document).on('click', '.top_menu', function(e) {
    e.preventDefault();
    $('#fixed_menu').toggleClass('active');
    $('#overlay').toggleClass('active');
    $('body').toggleClass('fixed');
});

$(document).on('click', '#fixed_menu .close', function(e) {
    e.preventDefault();
    $('#fixed_menu').removeClass('active');
    $('#overlay').removeClass('active');
    $('body').removeClass('fixed');
});
